export default "__VITE_ASSET__909a5d8e__"